import { readLocalCart, setLocalCartMember } from "./cart-state";
import type { TrustedTerminalIdentity } from "./terminal-state";

/**
 * Receivable collection is a completed customer task. After canonical ACK,
 * return the POS to anonymous-member context without touching cart lines.
 *
 * The expected customer guard prevents a late background retry from clearing
 * a different customer who may have been selected after the original request.
 */
export async function clearSettledCustomerMemberContext(
  identity: TrustedTerminalIdentity,
  expectedCustomerId: string,
) {
  const cart = await readLocalCart(identity);
  if (cart.selectedMember?.customerId !== expectedCustomerId) return false;
  await setLocalCartMember(identity, cart, null);
  return true;
}
